import {
  initReactI18next,
  instance
} from "../chunk-6N4NEKWU.mjs";
import "../chunk-D57E6H3M.mjs";

// src/i18n/instance.ts
import en from "./locales/en.mjs";
var SUPPORTED_LOCALES = ["en", "de", "fr", "it", "es", "nl", "ja", "zh-CN", "zh-TW"];
var DEFAULT_LOCALE = "en";
function normalizeLocale(locale) {
  if (!locale) return DEFAULT_LOCALE;
  const lower = locale.toLowerCase();
  if (lower.startsWith("zh-hans") || lower === "zh-cn" || lower === "zh") return "zh-CN";
  if (lower.startsWith("zh-hant") || lower === "zh-tw" || lower === "zh-hk" || lower === "zh-mo") return "zh-TW";
  const base = lower.split("-")[0];
  const match = SUPPORTED_LOCALES.find((l) => l === base);
  return match ?? DEFAULT_LOCALE;
}
var LOCALE_LOADERS = {
  "de": () => import("./locales/de.mjs"),
  "fr": () => import("./locales/fr.mjs"),
  "it": () => import("./locales/it.mjs"),
  "es": () => import("./locales/es.mjs"),
  "nl": () => import("./locales/nl.mjs"),
  "ja": () => import("./locales/ja.mjs"),
  "zh-CN": () => import("./locales/zh-CN.mjs"),
  "zh-TW": () => import("./locales/zh-TW.mjs")
};
function createLocaleSwitcher(instance2, loaders) {
  const pending = /* @__PURE__ */ new Map();
  let latest = 0;
  const load = (locale) => {
    let promise = pending.get(locale);
    if (!promise) {
      promise = loaders[locale]().then(
        (module) => {
          instance2.addResourceBundle(locale, "translation", module.default, true, true);
        },
        (error) => {
          pending.delete(locale);
          throw error;
        }
      );
      pending.set(locale, promise);
    }
    return promise;
  };
  return (locale) => {
    const target = normalizeLocale(locale);
    const request = ++latest;
    const apply = (next) => {
      if (request !== latest || instance2.language === next) return Promise.resolve();
      return instance2.changeLanguage(next).then(() => void 0, () => void 0);
    };
    if (target === DEFAULT_LOCALE || instance2.hasResourceBundle(target, "translation")) return apply(target);
    return load(target).then(() => apply(target), (error) => {
      console.warn(`[@buyscout/components] could not load the ${target} catalog; showing English`, error);
      return apply(DEFAULT_LOCALE);
    });
  };
}
function createCatalogExtender(instance2) {
  const extended = /* @__PURE__ */ new Set();
  return (en2, loaders) => {
    if (extended.has(loaders)) return;
    extended.add(loaders);
    instance2.addResourceBundle(DEFAULT_LOCALE, "translation", en2, true, true);
    const requested = /* @__PURE__ */ new Set();
    const loadFor = (language) => {
      const locale = normalizeLocale(language);
      if (locale === DEFAULT_LOCALE || requested.has(locale)) return;
      requested.add(locale);
      loaders[locale]().then(
        (module) => {
          instance2.addResourceBundle(locale, "translation", module.default, true, true);
          if (instance2.language === locale) void instance2.changeLanguage(locale);
        },
        (error) => {
          requested.delete(locale);
          console.warn(`[@buyscout/components] could not load extra ${locale} keys; showing English`, error);
        }
      );
    };
    loadFor(instance2.language);
    instance2.on("languageChanged", loadFor);
  };
}
var componentsI18n = instance.createInstance();
void componentsI18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false
});
var loadComponentsLocale = createLocaleSwitcher(componentsI18n, LOCALE_LOADERS);
var extendComponentsCatalog = createCatalogExtender(componentsI18n);
function setComponentsLocale(locale) {
  void loadComponentsLocale(locale);
}
export {
  SUPPORTED_LOCALES,
  componentsI18n,
  createCatalogExtender,
  createLocaleSwitcher,
  extendComponentsCatalog,
  loadComponentsLocale,
  normalizeLocale,
  setComponentsLocale
};
//# sourceMappingURL=instance.mjs.map